"use strict";

module.exports = function () {
    $("body").on("show.bs.tooltip", "[data-toggle='tooltip']", function () {
        $("[data-toggle='tooltip']").not(this).tooltip("hide");
    });
};
